import sweetalert from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { Injectable } from '@angular/core';

@Injectable()
export class SweetAlertService {
    constructor() { }

    swal(options) {
        return sweetalert(options);
    }

    prompt(options) {
        const baseOptions = {
            showCancelButton: true,
            confirmButtonText: 'Submit',
            input: 'text'
        };
        return sweetalert(Object.assign(baseOptions, options));
    }

    confirm(options) {
        const baseOptions = {
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            type: 'warning',
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-secondary m-btn m-btn--pill m-btn--icon'
        };
        return sweetalert(Object.assign(baseOptions, options));
    }

    alert(message, options) {
        const baseOptions = {
            position: 'top-right',
            type: 'info',
            showConfirmButton: false,
            timer: 3500,
            text: message
        };
        return sweetalert(Object.assign(baseOptions, options));
    }

    question(message, options = {}) {
        return this.alert(message, Object.assign({ type: 'question' }, options));
    }

    success(message, options = {}) {
        return this.alert(
            message,
            Object.assign(
                {
                    type: 'success'
                },
                options
            )
        );
    }

    error(message, options = {}) {
        return this.alert(message, Object.assign({ type: 'error' }, options));
    }

    warn(message, options = {}) {
        return this.alert(message, Object.assign({ type: 'warn' }, options));
    }

    info(message, options = {}) {
        return this.alert(message, Object.assign({ type: 'info' }, options));
    }

    confirmInfo(message, options = {}) {
        var baseOptions = {
            showCancelButton: false,
            title: message,
            confirmButtonText: 'Ok'
        };
        return this.confirm(Object.assign(baseOptions, options));
    }

    confirmDelete(options = {}) {
        var baseOptions = {
            title: 'Are you sure to Delete?',
            text: 'You will not be able to recover the data'
        };
        return this.confirm(Object.assign(baseOptions, options));
    }

    successDelete(options = {}) {
        return this.success('Deleted successfully!', options);
    }

    successUpdate(options = {}) {
        return this.success('Updated successfully!', options);
    }

    successCreate(options = {}) {
        return this.success('Inserted successfully!', options);
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/sweetalert.service.ts